import {
    NEW_CONTA_CHEQUE_PRE_DATADO_CADASTRO_SUCCESS,
    TABLE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_PENDING,
    TABLE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_SUCCESS,
    TABLE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_FAILURE,
    LIST_CONTA_CHEQUE_PRE_DATADO_CADASTRO_PENDING,
    LIST_CONTA_CHEQUE_PRE_DATADO_CADASTRO_SUCCESS,
    LIST_CONTA_CHEQUE_PRE_DATADO_CADASTRO_FAILURE,
    FIND_CONTA_CHEQUE_PRE_DATADO_CADASTRO_PENDING,
    FIND_CONTA_CHEQUE_PRE_DATADO_CADASTRO_SUCCESS,
    FIND_CONTA_CHEQUE_PRE_DATADO_CADASTRO_FAILURE,
    DELETE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_PENDING,
    DELETE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_SUCCESS,
    DELETE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_FAILURE,
    CREATE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_PENDING,
    CREATE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_SUCCESS,
    CREATE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function contaChequePreDatadoCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_CONTA_CHEQUE_PRE_DATADO_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case LIST_CONTA_CHEQUE_PRE_DATADO_CADASTRO_PENDING:
        case FIND_CONTA_CHEQUE_PRE_DATADO_CADASTRO_PENDING:
        case DELETE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_PENDING:
        case CREATE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_PENDING:
        case TABLE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_CONTA_CHEQUE_PRE_DATADO_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_CONTA_CHEQUE_PRE_DATADO_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_CONTA_CHEQUE_PRE_DATADO_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_CONTA_CHEQUE_PRE_DATADO_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_SUCCESS:
        case CREATE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case DELETE_CONTA_CHEQUE_PRE_DATADO_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { contaChequePreDatadoCadastroReducer };